import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68181588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_223)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.69887 4.86683C4.57404 3.99167 5.76102 3.5 6.9987 3.5H20.9987C22.2364 3.5 23.4234 3.99167 24.2985 4.86683C25.1737 5.742 25.6654 6.92899 25.6654 8.16667V17.5C25.6654 18.7377 25.1737 19.9247 24.2985 20.7998C23.4234 21.675 22.2364 22.1667 20.9987 22.1667H15.4885L9.93228 25.5004C9.57186 25.7167 9.12298 25.7223 8.75722 25.5152C8.39146 25.3081 8.16537 24.9203 8.16537 24.5V22.1667H6.9987C5.76102 22.1667 4.57404 21.675 3.69887 20.7998C2.8237 19.9247 2.33203 18.7377 2.33203 17.5V8.16667C2.33203 6.92899 2.8237 5.742 3.69887 4.86683ZM13.1752 8.55792C13.8345 8.426 14.519 8.52093 15.1175 8.82725C15.7182 9.13357 16.1981 9.63331 16.4799 10.2459C16.7619 10.8587 16.8291 11.5487 16.6706 12.2045C16.5121 12.8603 16.1373 13.4434 15.6065 13.8599C15.0758 14.2764 14.4202 14.5018 13.7456 14.4998C13.1933 14.4981 12.7469 14.049 12.7486 13.4968C12.7502 12.9445 13.1993 12.4981 13.7516 12.4998C13.9764 12.5004 14.195 12.4253 14.3719 12.2865C14.5488 12.1477 14.6738 11.9533 14.7266 11.7347C14.7794 11.5161 14.757 11.2861 14.663 11.0818C14.569 10.8775 14.4089 10.7109 14.2086 10.6088L14.2066 10.6078C14.0097 10.5069 13.7845 10.4756 13.5676 10.5191C13.3506 10.5625 13.1548 10.678 13.0118 10.8468C12.655 11.2684 12.024 11.3209 11.6025 10.964C11.1809 10.6072 11.1285 9.97623 11.4853 9.55469C11.9199 9.04121 12.5155 8.68991 13.1752 8.55792ZM14.2485 15.4998C14.8008 15.4998 15.2485 15.9475 15.2485 16.4998V16.5098C15.2485 17.062 14.8008 17.5098 14.2485 17.5098C13.6962 17.5098 13.2485 17.062 13.2485 16.5098V16.4998C13.2485 15.9475 13.6962 15.4998 14.2485 15.4998Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_223" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "28",
        height: "28",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8645)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM16.9937 13.2281C17.78 12.4417 18.8465 12 19.9585 12C21.0705 12 22.137 12.4417 22.9233 13.2281C23.7096 14.0144 24.1514 15.0809 24.1514 16.1929C24.1514 17.3049 23.7096 18.3714 22.9233 19.1577C22.137 19.944 21.0705 20.3857 19.9585 20.3857C18.8465 20.3857 17.78 19.944 16.9937 19.1577C16.2074 18.3714 15.7656 17.3049 15.7656 16.1929C15.7656 15.0809 16.2074 14.0144 16.9937 13.2281ZM15.2281 22.9379C16.0144 22.1516 17.0809 21.7098 18.1929 21.7098H21.7237C22.8357 21.7098 23.9022 22.1516 24.6885 22.9379C25.4748 23.7242 25.9166 24.7907 25.9166 25.9027V27.6681C25.9166 28.0338 25.6202 28.3302 25.2545 28.3302H14.662C14.2964 28.3302 14 28.0338 14 27.6681V25.9027C14 24.7907 14.4417 23.7242 15.2281 22.9379Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8645" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8657)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM27.3324 18.3332C27.3324 17.4127 26.5862 16.6665 25.6657 16.6665C24.7452 16.6665 23.999 17.4127 23.999 18.3332V26.6665C23.999 27.587 24.7452 28.3332 25.6657 28.3332C26.5862 28.3332 27.3324 27.587 27.3324 26.6665V18.3332ZM14.9997 23.3335C15.9201 23.3335 16.6663 24.0797 16.6663 25.0002V26.6668C16.6663 27.5873 15.9201 28.3335 14.9997 28.3335C14.0792 28.3335 13.333 27.5873 13.333 26.6668V25.0002C13.333 24.0797 14.0792 23.3335 14.9997 23.3335ZM21.9993 21.6667C21.9993 20.7462 21.2532 20 20.3327 20C19.4122 20 18.666 20.7462 18.666 21.6667V26.6667C18.666 27.5871 19.4122 28.3333 20.3327 28.3333C21.2532 28.3333 21.9993 27.5871 21.9993 26.6667V21.6667Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8657" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM21.2203 12.1195C21.4562 12.2652 21.5997 12.5227 21.5997 12.8V15.2001C21.7783 15.2 21.9555 15.2596 22.1003 15.3755L26.1003 18.5754C26.2901 18.7273 26.4005 18.9571 26.4005 19.2001V26.3999H27.2C27.6418 26.3999 28 26.7581 28 27.1999C28 27.6418 27.6418 27.9999 27.2 27.9999H25.619L25.6005 28.0001H21.6006L21.5821 27.9999H20.8098L20.7997 28L20.7897 27.9999H14.4098L14.3997 28L14.3897 27.9999H12.8C12.3582 27.9999 12 27.6418 12 27.1999C12 26.7581 12.3582 26.3999 12.8 26.3999H13.5997V16C13.5997 15.697 13.7709 15.42 14.042 15.2845L20.4419 12.0845C20.6899 11.9605 20.9845 11.9737 21.2203 12.1195ZM24.8005 26.3999V19.5846L22.4006 17.6646V26.3999H24.8005ZM16 24.8C16 24.3582 16.3582 24 16.8 24H18.4C18.8418 24 19.2 24.3582 19.2 24.8C19.2 25.2418 18.8418 25.6 18.4 25.6H16.8C16.3582 25.6 16 25.2418 16 24.8ZM16.8 21C16.3582 21 16 21.3582 16 21.8C16 22.2418 16.3582 22.6 16.8 22.6H18.4C18.8418 22.6 19.2 22.2418 19.2 21.8C19.2 21.3582 18.8418 21 18.4 21H16.8ZM16 18.8C16 18.3582 16.3582 18 16.8 18H18.4C18.8418 18 19.2 18.3582 19.2 18.8C19.2 19.2418 18.8418 19.6 18.4 19.6H16.8C16.3582 19.6 16 19.2418 16 18.8Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8699)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM20.6146 12.7881L20.5474 12.7161C20.4678 12.6416 20.3739 12.5841 20.2714 12.5472C20.1688 12.5103 20.0598 12.4948 19.9511 12.5015C19.8423 12.5083 19.736 12.5372 19.6388 12.5864C19.5416 12.6357 19.4555 12.7043 19.3858 12.7881L15.6241 17.3001H12.8001L12.7097 17.3049C12.5964 17.3178 12.4872 17.3548 12.3894 17.4133C12.2915 17.4718 12.2073 17.5505 12.1424 17.6442C12.0775 17.738 12.0333 17.8445 12.0129 17.9566C11.9925 18.0688 11.9963 18.184 12.0241 18.2946L13.6241 24.6947L13.6521 24.8427C13.8945 25.9731 14.7857 26.8563 15.8817 26.8987L24.0002 26.9003L24.1362 26.8995C25.2619 26.8539 26.1835 25.8915 26.3899 24.6291L27.9771 18.2946L27.9931 18.205C28.008 18.0921 27.9987 17.9773 27.9657 17.8683C27.9326 17.7593 27.8767 17.6586 27.8017 17.5729C27.7266 17.4873 27.6342 17.4186 27.5305 17.3716C27.4267 17.3246 27.3142 17.3002 27.2003 17.3001H24.3747L20.6146 12.7881ZM17.7081 17.3001L20.0002 14.5497L22.2922 17.3001H17.7081Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8699" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "premium",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_588_2539)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.0003 4C18.1509 4 18.2995 4.034 18.435 4.09945C18.5706 4.1649 18.6897 4.26012 18.7833 4.378L18.8573 4.486L21.8573 9.486C21.9556 9.64995 22.0048 9.83863 21.9991 10.0297C21.9934 10.2207 21.9331 10.4062 21.8253 10.564L21.7453 10.667L13.2153 20.2C13.0569 20.3616 12.8679 20.4899 12.6592 20.5775C12.4506 20.6651 12.2266 20.7101 12.0003 20.71C11.6003 20.71 11.2153 20.57 10.8903 20.293L10.7553 20.167L2.25531 10.667C2.12743 10.5243 2.04324 10.3479 2.01275 10.1587C1.98225 9.96958 2.00675 9.77564 2.08331 9.6L2.14331 9.485L5.15631 4.463L5.22031 4.373C5.26608 4.31606 5.31807 4.26441 5.37531 4.219L5.46431 4.155L5.55231 4.105L5.60231 4.082L5.66231 4.057L5.77131 4.025L5.88331 4.005L6.00031 4H18.0003ZM9.11431 7.943C8.88697 7.80686 8.6149 7.76652 8.35784 7.83083C8.10078 7.89514 7.87975 8.05885 7.74331 8.286L7.14331 9.286L7.08331 9.402C7.00677 9.57848 6.98276 9.77329 7.01415 9.96308C7.04555 10.1529 7.13102 10.3296 7.26031 10.472L9.26031 12.672L9.35031 12.76C9.53542 12.9184 9.77199 13.0038 10.0156 13.0001C10.2592 12.9964 10.4931 12.9039 10.6733 12.74L10.7603 12.65C10.9187 12.4649 11.0041 12.2283 11.0004 11.9847C10.9967 11.7411 10.9042 11.5072 10.7403 11.327L9.23931 9.677L9.45731 9.314L9.51231 9.211C9.6128 8.98758 9.62778 8.73505 9.55442 8.50132C9.48106 8.26759 9.32445 8.06892 9.11431 7.943Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_588_2539" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8670)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM14.1667 12.3334C13.4594 12.3334 12.7811 12.6143 12.281 13.1144C11.781 13.6145 11.5 14.2928 11.5 15V25C11.5 25.7073 11.781 26.3856 12.281 26.8857C12.7811 27.3858 13.4594 27.6667 14.1667 27.6667H25.8333C26.5406 27.6667 27.2189 27.3858 27.719 26.8857C28.219 26.3856 28.5 25.7073 28.5 25V15C28.5 14.2928 28.219 13.6145 27.719 13.1144C27.2189 12.6143 26.5406 12.3334 25.8333 12.3334H14.1667ZM14.8335 16.6666C14.8335 16.1143 15.2812 15.6666 15.8335 15.6666H24.1668C24.7191 15.6666 25.1668 16.1143 25.1668 16.6666C25.1668 17.2189 24.7191 17.6666 24.1668 17.6666H15.8335C15.2812 17.6666 14.8335 17.2189 14.8335 16.6666ZM14.8335 20C14.8335 19.4477 15.2812 19 15.8335 19H24.1668C24.7191 19 25.1668 19.4477 25.1668 20C25.1668 20.5523 24.7191 21 24.1668 21H15.8335C15.2812 21 14.8335 20.5523 14.8335 20ZM15.8335 22.3334C15.2812 22.3334 14.8335 22.7811 14.8335 23.3334C14.8335 23.8857 15.2812 24.3334 15.8335 24.3334H24.1668C24.7191 24.3334 25.1668 23.8857 25.1668 23.3334C25.1668 22.7811 24.7191 22.3334 24.1668 22.3334H15.8335Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8670" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_12 = {
  key: 0,
  class: "premium",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_588_2539)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18.0003 4C18.1509 4 18.2995 4.034 18.435 4.09945C18.5706 4.1649 18.6897 4.26012 18.7833 4.378L18.8573 4.486L21.8573 9.486C21.9556 9.64995 22.0048 9.83863 21.9991 10.0297C21.9934 10.2207 21.9331 10.4062 21.8253 10.564L21.7453 10.667L13.2153 20.2C13.0569 20.3616 12.8679 20.4899 12.6592 20.5775C12.4506 20.6651 12.2266 20.7101 12.0003 20.71C11.6003 20.71 11.2153 20.57 10.8903 20.293L10.7553 20.167L2.25531 10.667C2.12743 10.5243 2.04324 10.3479 2.01275 10.1587C1.98225 9.96958 2.00675 9.77564 2.08331 9.6L2.14331 9.485L5.15631 4.463L5.22031 4.373C5.26608 4.31606 5.31807 4.26441 5.37531 4.219L5.46431 4.155L5.55231 4.105L5.60231 4.082L5.66231 4.057L5.77131 4.025L5.88331 4.005L6.00031 4H18.0003ZM9.11431 7.943C8.88697 7.80686 8.6149 7.76652 8.35784 7.83083C8.10078 7.89514 7.87975 8.05885 7.74331 8.286L7.14331 9.286L7.08331 9.402C7.00677 9.57848 6.98276 9.77329 7.01415 9.96308C7.04555 10.1529 7.13102 10.3296 7.26031 10.472L9.26031 12.672L9.35031 12.76C9.53542 12.9184 9.77199 13.0038 10.0156 13.0001C10.2592 12.9964 10.4931 12.9039 10.6733 12.74L10.7603 12.65C10.9187 12.4649 11.0041 12.2283 11.0004 11.9847C10.9967 11.7411 10.9042 11.5072 10.7403 11.327L9.23931 9.677L9.45731 9.314L9.51231 9.211C9.6128 8.98758 9.62778 8.73505 9.55442 8.50132C9.48106 8.26759 9.32445 8.06892 9.11431 7.943Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_588_2539" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "currentColor"
    })
  ])
], -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8717)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM24.8 14.1H27.2C27.4122 14.1 27.6157 14.1843 27.7657 14.3343C27.9157 14.4843 28 14.6878 28 14.9V17.3C28 18.1487 27.6629 18.9626 27.0627 19.5627C26.4626 20.1629 25.6487 20.5 24.8 20.5H23.568C22.8444 21.3073 21.8688 21.8459 20.8 22.028V23.7H21.6C22.2365 23.7 22.847 23.9529 23.2971 24.4029C23.7471 24.853 24 25.4635 24 26.1V27.7C24 27.9122 23.9157 28.1157 23.7657 28.2657C23.6157 28.4157 23.4122 28.5 23.2 28.5H16.8C16.5878 28.5 16.3843 28.4157 16.2343 28.2657C16.0843 28.1157 16 27.9122 16 27.7V26.1C16 25.4635 16.2529 24.853 16.7029 24.4029C17.153 23.9529 17.7635 23.7 18.4 23.7H19.2V22.028C18.1312 21.8459 17.1556 21.3073 16.432 20.5H15.2C14.3513 20.5 13.5374 20.1629 12.9373 19.5627C12.3371 18.9626 12 18.1487 12 17.3V14.9C12 14.6878 12.0843 14.4843 12.2343 14.3343C12.3843 14.1843 12.5878 14.1 12.8 14.1H15.2V13.3C15.2 13.0878 15.2843 12.8843 15.4343 12.7343C15.5843 12.5843 15.7878 12.5 16 12.5H24C24.2122 12.5 24.4157 12.5843 24.5657 12.7343C24.7157 12.8843 24.8 13.0878 24.8 13.3V14.1ZM14.0686 18.4314C14.3687 18.7314 14.7757 18.9 15.2 18.9H15.48C15.2964 18.3864 15.2018 17.8454 15.2 17.3V15.7H13.6V17.3C13.6 17.7243 13.7686 18.1313 14.0686 18.4314ZM25.9314 18.4314C26.2314 18.1313 26.4 17.7243 26.4 17.3V15.7H24.8V17.3C24.7982 17.8454 24.7036 18.3864 24.52 18.9H24.8C25.2243 18.9 25.6313 18.7314 25.9314 18.4314Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8717" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8987)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM12.8988 17.319C12.745 17.319 12.5976 17.3801 12.4889 17.4889C12.3801 17.5976 12.319 17.745 12.319 17.8988V19.6381H13.4786V17.8988C13.4786 17.745 13.4175 17.5976 13.3088 17.4889C13.2 17.3801 13.0526 17.319 12.8988 17.319ZM13.4786 21.9571V23.1167C13.4786 23.757 13.9977 24.2762 14.6381 24.2762C15.2785 24.2762 15.7976 23.757 15.7976 23.1167V20.7976V17.8988C15.7976 17.13 15.4922 16.3927 14.9486 15.849C14.4049 15.3054 13.6676 15 12.8988 15C12.13 15 11.3927 15.3054 10.849 15.849C10.3054 16.3927 10 17.13 10 17.8988V20.7976V23.1167C10 23.757 10.5191 24.2762 11.1595 24.2762C11.7999 24.2762 12.319 23.757 12.319 23.1167V21.9571H13.4786ZM17.3051 16.1595C17.3051 15.5191 17.8242 15 18.4646 15H19.6241C20.5467 15 21.4315 15.3665 22.0839 16.0189C22.7362 16.6712 23.1027 17.556 23.1027 18.4786V20.7976C23.1027 21.7202 22.7362 22.605 22.0839 23.2573C21.4315 23.9097 20.5467 24.2762 19.6241 24.2762H18.4646C17.8242 24.2762 17.3051 23.757 17.3051 23.1167V16.1595ZM19.6241 17.319V21.9571C19.9317 21.9571 20.2266 21.835 20.4441 21.6175C20.6615 21.4001 20.7837 21.1051 20.7837 20.7976V18.4786C20.7837 18.171 20.6615 17.8761 20.4441 17.6587C20.2266 17.4412 19.9317 17.319 19.6241 17.319ZM24.8817 15.6792C25.3166 15.2443 25.9065 15 26.5215 15H27.9709C28.5091 15 29.0252 15.2138 29.4058 15.5943C29.7863 15.9749 30.0001 16.491 30.0001 17.0292C30.0001 17.6696 29.481 18.1887 28.8406 18.1887C28.3003 18.1887 27.8463 17.8192 27.7176 17.319L26.5215 17.319V18.4786H27.681C28.2961 18.4786 28.886 18.7229 29.3209 19.1578C29.7558 19.5927 30.0001 20.1826 30.0001 20.7976V21.9571C30.0001 22.5722 29.7558 23.162 29.3209 23.597C28.886 24.0319 28.2961 24.2762 27.681 24.2762H26.2316C25.1112 24.2762 24.2025 23.3675 24.2025 22.247C24.2025 21.6066 24.7216 21.0875 25.362 21.0875C25.9023 21.0875 26.3563 21.457 26.485 21.9571H27.681V20.7976H26.5215C25.9065 20.7976 25.3166 20.5533 24.8817 20.1184C24.4468 19.6835 24.2025 19.0936 24.2025 18.4786V17.319C24.2025 16.704 24.4468 16.1141 24.8817 15.6792Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8987" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "currentColor"
      })
    ])
  ])
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4218_21452)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.44078 7.44078C9.00358 5.87797 11.1232 5 13.3333 5H26.6667C28.8768 5 30.9964 5.87797 32.5592 7.44078C34.122 9.00358 35 11.1232 35 13.3333V26.6667C35 28.8768 34.122 30.9964 32.5592 32.5592C30.9964 34.122 28.8768 35 26.6667 35H13.3333C11.1232 35 9.00358 34.122 7.44078 32.5592C5.87797 30.9964 5 28.8768 5 26.6667V13.3333C5 11.1232 5.87797 9.00358 7.44078 7.44078ZM20.8296 29.4037C20.4084 29.6346 20.0477 29.75 19.7476 29.75C19.4129 29.75 19.156 29.6144 18.9771 29.3431C18.804 29.0777 18.7175 28.6968 18.7175 28.2005V20.8165C18.7175 20.4991 18.7492 20.2307 18.8127 20.0114C18.8819 19.7921 18.9945 19.5988 19.1503 19.4314C19.3119 19.2641 19.5254 19.1025 19.7909 18.9467L26.1967 15.2503C26.6006 15.0195 26.9527 14.9041 27.2528 14.9041C27.5759 14.9041 27.827 15.0368 28.0059 15.3023C28.1906 15.5678 28.2829 15.9573 28.2829 16.4709V23.8636C28.2829 24.181 28.2483 24.4493 28.179 24.6686C28.1155 24.8879 28.0059 25.0813 27.8501 25.2486C27.6943 25.416 27.4865 25.5747 27.2268 25.7247L20.8296 29.4037ZM16.7438 27.5772C16.5764 27.6869 16.4033 27.7417 16.2244 27.7417C15.9531 27.7417 15.7281 27.6234 15.5492 27.3868C15.376 27.1502 15.2895 26.8385 15.2895 26.4519V18.6783C15.2895 18.3494 15.3097 18.0983 15.3501 17.9252C15.3905 17.7463 15.477 17.5963 15.6098 17.4751C15.7425 17.3481 15.9503 17.2038 16.233 17.0422L23.0457 13.1208C23.3112 12.9766 23.5622 12.9044 23.7988 12.9044C24.0585 12.9044 24.272 12.991 24.4394 13.1641C24.6068 13.3315 24.6847 13.5623 24.6731 13.8566L17.142 18.2022C17.0323 18.2657 16.9486 18.3263 16.8909 18.384C16.8332 18.4359 16.7928 18.4994 16.7697 18.5744C16.7524 18.6495 16.7438 18.7533 16.7438 18.8861V27.5772ZM13.4543 25.6814C13.2812 25.7911 13.108 25.8459 12.9349 25.8459C12.6579 25.8459 12.4328 25.7276 12.2597 25.491C12.0866 25.2486 12 24.9341 12 24.5474V16.7825C12 16.4536 12.0202 16.1997 12.0606 16.0208C12.101 15.8419 12.1876 15.6918 12.3203 15.5706C12.4588 15.4494 12.6694 15.3081 12.9522 15.1465L19.7562 11.2337C20.0102 11.0779 20.2641 11 20.518 11C20.7719 11 20.9797 11.0866 21.1413 11.2597C21.3086 11.4271 21.3923 11.6579 21.3923 11.9522L13.8525 16.2978C13.7428 16.3613 13.6592 16.4219 13.6015 16.4796C13.5437 16.5315 13.5033 16.5979 13.4803 16.6787C13.4629 16.7595 13.4543 16.8605 13.4543 16.9816V25.6814Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4218_21452" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_589_8947)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M17.0911 4.76113C17.1224 4.89032 17.1837 5.01029 17.2701 5.1113C17.3565 5.21231 17.4656 5.2915 17.5883 5.34243C17.7111 5.39336 17.8442 5.4146 17.9767 5.40441C18.1092 5.39422 18.2375 5.3529 18.3511 5.2838C21.1966 3.5513 24.4527 6.8063 22.7202 9.6518C22.6511 9.76527 22.6098 9.89345 22.5995 10.0259C22.5892 10.1584 22.6104 10.2914 22.6612 10.4142C22.712 10.5369 22.791 10.646 22.8919 10.7324C22.9928 10.8189 23.1126 10.8804 23.2417 10.9118C26.4792 11.697 26.4792 16.3018 23.2417 17.0881C23.1125 17.1194 22.9926 17.1808 22.8916 17.2672C22.7905 17.3536 22.7114 17.4626 22.6604 17.5854C22.6095 17.7082 22.5883 17.8413 22.5984 17.9738C22.6086 18.1063 22.65 18.2346 22.7191 18.3481C24.4516 21.1936 21.1966 24.4498 18.3511 22.7173C18.2376 22.6482 18.1094 22.6068 17.9769 22.5966C17.8445 22.5863 17.7115 22.6074 17.5887 22.6583C17.4659 22.7091 17.3569 22.7881 17.2704 22.889C17.184 22.9899 17.1225 23.1097 17.0911 23.2388C16.3059 26.4763 11.7011 26.4763 10.9147 23.2388C10.8834 23.1096 10.8221 22.9896 10.7357 22.8886C10.6493 22.7876 10.5402 22.7084 10.4175 22.6575C10.2947 22.6066 10.1616 22.5853 10.0291 22.5955C9.89654 22.6057 9.76828 22.647 9.65473 22.7161C6.80923 24.4486 3.55306 21.1936 5.28556 18.3481C5.35467 18.2347 5.39603 18.1065 5.40629 17.974C5.41654 17.8415 5.39541 17.7085 5.3446 17.5858C5.29379 17.463 5.21474 17.354 5.11387 17.2675C5.013 17.181 4.89315 17.1196 4.76406 17.0881C1.52656 16.303 1.52656 11.6981 4.76406 10.9118C4.89325 10.8805 5.01322 10.8191 5.11423 10.7327C5.21524 10.6463 5.29443 10.5373 5.34536 10.4145C5.39629 10.2917 5.41753 10.1587 5.40734 10.0261C5.39715 9.89361 5.35583 9.76535 5.28673 9.6518C3.55423 6.8063 6.80923 3.55013 9.65473 5.28263C9.76809 5.35226 9.89633 5.39404 10.0289 5.40457C10.1616 5.41509 10.2948 5.39405 10.4177 5.34318C10.5406 5.2923 10.6498 5.21303 10.7361 5.11187C10.8225 5.0107 10.8837 4.89051 10.9147 4.76113C11.6999 1.52363 16.3047 1.52363 17.0911 4.76113ZM14.0029 10.5C13.0746 10.5 12.1844 10.8687 11.528 11.5251C10.8716 12.1815 10.5029 13.0717 10.5029 14C10.5029 14.9282 10.8716 15.8185 11.528 16.4748C12.1844 17.1312 13.0746 17.5 14.0029 17.5C14.9312 17.5 15.8214 17.1312 16.4778 16.4748C17.1341 15.8185 17.5029 14.9282 17.5029 14C17.5029 13.0717 17.1341 12.1815 16.4778 11.5251C15.8214 10.8687 14.9312 10.5 14.0029 10.5Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_589_8947" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "28",
        height: "28",
        fill: "white"
      })
    ])
  ])
], -1))

import router from "@/router";
import { ref, onMounted, watch } from "vue";
import i18n from "@/i18n";
import { useProfilData } from "@/stores/profilData";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheSidebar',
  setup(__props) {

const visitedPages = ref<string[]>([]);
const profilData = useProfilData();

onMounted(() => {
	visitedPages.value = JSON.parse(
		localStorage.getItem("visitedPages") || "[]"
	);
});

watch(
	() => router.currentRoute.value.path,
	() => {
		// const path is the first segment of the path
		const path = router.currentRoute.value.path.split("/")[1];

		if (!visitedPages.value.includes(path)) {
			visitedPages.value.push(path);
			localStorage.setItem(
				"visitedPages",
				JSON.stringify(visitedPages.value)
			);
		}
	}
);

const isAssistanceModalOpen = ref(false);
const isGlossaryModalOpen = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: "/help",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/help' || _ctx.$route.path.startsWith('/help/'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.help.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/profile",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/profile' ||
					_ctx.$route.path.startsWith('/profile/'),
				new: !visitedPages.value.includes('profile'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.profile.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/analytics",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/analytics' ||
					_ctx.$route.path.startsWith('/analytics/'),
				new: !visitedPages.value.includes('analytics'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.analytics.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/buildings",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/buildings' ||
					_ctx.$route.path.startsWith('/buildings/'),
				new: !visitedPages.value.includes('buildings'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.buildings.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/products",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/products' ||
					_ctx.$route.path.startsWith('/products/'),
				new: !visitedPages.value.includes('products'),
				grey: _unref(profilData).getSubscription === '',
			})
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.products.title")) + " ", 1),
        (_unref(profilData).getSubscription === '')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/articles",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/articles' ||
					_ctx.$route.path.startsWith('/articles/'),
				new: !visitedPages.value.includes('articles'),
				grey: _unref(profilData).getSubscription === '',
			})
    }, {
      default: _withCtx(() => [
        _hoisted_11,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.articles.title")) + " ", 1),
        (_unref(profilData).getSubscription === '')
          ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/competitions",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/competitions' ||
					_ctx.$route.path.startsWith('/competitions/'),
				new: !visitedPages.value.includes('competitions'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_16,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.competitions.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/ads",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/ads' || _ctx.$route.path.startsWith('/ads/'),
				new: !visitedPages.value.includes('ads'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_17,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.ads.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/oona-kit",
      class: _normalizeClass({
			active: _ctx.$route.path === '/oona-kit' || _ctx.$route.path.startsWith('/oona-kit/'),
			new: !visitedPages.value.includes('oona-kit'),
		})
    }, {
      default: _withCtx(() => [
        _hoisted_18,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.oona-kit.title")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_RouterLink, {
      to: "/settings",
      class: _normalizeClass({
				active:
					_ctx.$route.path === '/settings' ||
					_ctx.$route.path.startsWith('/settings/'),
			})
    }, {
      default: _withCtx(() => [
        _hoisted_19,
        _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t("routes.settings.title")), 1)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})